

$('.js-tab-button span').on('click',function(){
  if($(this).hasClass('active')){
    return false;
  }
  var num = $(this).closest('.js-tab-wrap').find('.js-tab-button span').index($(this));
  $(this).closest('.js-tab-wrap').find('.js-tab-button span').removeClass('active');  $(this).closest('.js-tab-wrap').find('.js-tab-button span').eq(num).addClass('active');
  $(this).closest('.js-tab-wrap').find('.js-tab-box').removeClass('show');
  $(this).closest('.js-tab-wrap').find('.js-tab-box').eq(num).addClass('show');
});
